import { DateTimeObj } from '../../../../universal';
const parseDateTime = (createdAt) => {
    const parsedDateTime = DateTimeObj.parse(createdAt);
    if (parsedDateTime == null || !parsedDateTime.lx.isValid) {
        return null;
    }
    return parsedDateTime;
};
export const formatCompactTime = (createdAt) => {
    const parsedDateTime = parseDateTime(createdAt);
    return parsedDateTime?.fmt('HH:mm') ?? '';
};
export const formatFullDateTime = (createdAt) => {
    const parsedDateTime = parseDateTime(createdAt);
    return parsedDateTime?.fmt('dd MMM yyyy HH:mm:ss') ?? '';
};
export const formatSidebarTimestamp = (createdAt) => {
    const parsedDateTime = parseDateTime(createdAt);
    if (parsedDateTime == null) {
        return '';
    }
    const now = DateTimeObj.now();
    const isToday = parsedDateTime.date().fmt() === now.date().fmt();
    if (isToday) {
        return parsedDateTime.fmt('HH:mm') ?? '';
    }
    const isWithinLast7Days = parsedDateTime.date().diffDays(now.date()) >= -7;
    return parsedDateTime.fmt(isWithinLast7Days ? 'ccc' : 'dd/LL') ?? '';
};
//# sourceMappingURL=date-utils.js.map